import * as React from 'react';
import { cn } from '../utils/cn';

export interface TextInputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  containerClassName?: string;
}

export const TextInput = React.forwardRef<HTMLInputElement, TextInputProps>(
  ({
    label, className, containerClassName, required, ...props
  }, ref) => (
    <div
      className={cn(
        'w-full',
        containerClassName,
      )}
    >
      {label && (
      <label className="block text-sm font-medium text-gray-700 mb-1">
        {label}
        {required && <span className="text-gray-400 ml-0.5">*</span>}
      </label>
      )}
      <input
        ref={ref}
        className={cn(
          'block w-full rounded-md border border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500 px-3 py-2 text-base focus:outline-offset-2',
          className,
        )}
        required={required}
        {...props}
      />
    </div>
  ),
);
TextInput.displayName = 'TextInput';
